document.addEventListener("DOMContentLoaded", function(){

    /* Mobile menu */
    let menuHamburger = document.querySelector('.js-open-together-menu');
    let nav = document.querySelector('nav');
    let openMenu = false;

    if ( menuHamburger ) {

        menuHamburger.addEventListener('click', function(){

            if ( openMenu == false ) {
                openMenu = true;
                nav.classList.add('active');
            } else {
                openMenu = false;
                nav.classList.remove('active');
            }

        })
    }

    /* Scroll menu */
    let scrollMenu = document.querySelector('.js-scroll-menu');

    if ( scrollMenu ) {

        let showMenu = false;

        var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
        if ( (scrollTop > 400) && showMenu == false ) {
            activateMenu();
        }

        window.onscroll = function () {
            scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

            if ( scrollTop > 400 && showMenu == false ) {
                activateMenu();
            } else if ( scrollTop < 401 && showMenu == true ) {
                scrollMenu.classList.remove('visible');
                showMenu = false;
            }
        };

        function activateMenu() {
            scrollMenu.classList.add('visible');
            showMenu = true;

            if ( openMenu == true ) {
                openMenu = false;
                nav.classList.remove('active');
            }
        }

        let toTop = document.querySelector('.js-to-top');

        toTop.addEventListener('click',function(e){
            e.stopPropagation();

            const scrollToTop = () => {
                const c = document.documentElement.scrollTop || document.body.scrollTop;
                if (c > 0) {
                    window.requestAnimationFrame(scrollToTop);
                    window.scrollTo(0, c - c / 8);
                }
            };
            scrollToTop();
        });

    }

    /* Filter buttons active class */
    let filterBtns = document.querySelectorAll('.js-filter-btn');

    if ( filterBtns.length ) {

        let currentUrl = document.URL;
        filterBtns.forEach(btn => {
            if ( currentUrl == btn.getAttribute('href') ) {
                btn.classList.add('active-border');
            }
        })

    }

    let showSubHashtagsInput = document.querySelector('.js-show-sub-hashtags');
    let subHashtags = document.querySelectorAll('.js-sub-hashtags');

    if (showSubHashtagsInput) {
        showSubHashtagsInput.addEventListener('change', function(e) {
            if (subHashtags.length) {
                subHashtags.forEach(el => {
                    el.classList.toggle('toggled');
                });
            }
        });
    }

    /* Shuffle page */
    let shuffleItems = document.querySelectorAll('.js-shuffle-item');

    if ( shuffleItems.length ) {

        let shuffle = document.querySelector('.js-shuffle');
        let bgs = document.querySelectorAll('.js-bg');
        let currentInner = document.querySelector('.js-inner');
        let mainNav = document.querySelector('nav > div');

        let i = 0;
        let totalItems = shuffleItems.length;

        let switchingContent = false;

        setContent()
        switchMenu()

        shuffle.addEventListener('click',function(e){

            e.stopPropagation();

            if ( switchingContent == false ) {

                switchingContent = true;

                i++;
                if ( i == totalItems ) {
                    i = 0;
                }

                switchContent()
            }

        });

        function switchMenu() {

            if ( shuffleItems[i].dataset.image.length ) {
                mainNav.classList.add('white-menu');
            } else {
                mainNav.classList.remove('white-menu');
            }
        }

        function switchContent() {

            currentInner.style.opacity = '0';

            bgs.forEach(bg => {
                if ( bg.classList.contains('visible') ) {
                    bg.classList.add('hidden')
                } else {
                    bg.classList.add('visible')
                }
            })

            switchMenu()

            setTimeout(function(){
                currentInner.innerHTML = '';

                bgs.forEach(bg => {
                    if ( bg.classList.contains('hidden') ) {
                        bg.classList.remove('hidden')
                        bg.classList.remove('visible')
                    }
                })

                setContent();
            }, 300);
        }

        function setContent() {

            /* Setup current item */
            let current = shuffleItems[i];

            if ( current.dataset.image.length ) {
                currentInner.classList.add('top-aligned')
            } else {
                currentInner.classList.remove('top-aligned')
            }

            /* On page load */
            if ( i == 0 ) {
                if ( current.dataset.image.length ) {
                    bgs.forEach(bg => {
                        if ( bg.classList.contains('visible') ) {
                            bg.style.backgroundImage = 'linear-gradient(rgba(67, 29, 11, 0.4), rgba(67, 29, 11, 0.4)), url(' + current.dataset.image + ')';
                            bg.classList.add('has-img');
                        }
                    })
                } else {
                    bgs.forEach(bg => {
                        if ( bg.classList.contains('visible') ) {
                            bg.style.backgroundImage = 'none';
                            bg.classList.remove('has-img');
                        }
                    })
                }
            }

            currentInner.innerHTML = current.outerHTML;
            currentInner.style.opacity = '1';

            /* Prepare next item */
            let next = shuffleItems[i+1]

            if ( i == totalItems - 1 ) {
                next = shuffleItems[0]
            }

            if ( next.dataset.image.length ) {
                bgs.forEach(bg => {
                    if ( !bg.classList.contains('visible') ) {
                        bg.style.backgroundImage = 'linear-gradient(rgba(67, 29, 11, 0.4), rgba(67, 29, 11, 0.4)), url(' + next.dataset.image + ')';
                        bg.classList.add('has-img');
                    }
                })
            } else {
                bgs.forEach(bg => {
                    if ( !bg.classList.contains('visible') ) {
                        bg.style.backgroundImage = 'none';
                        bg.classList.remove('has-img');
                    }
                })
            }

            switchingContent = false;
        }
    }

    let accordions = document.querySelectorAll('.accordion');

    if (accordions.length) {

        accordions.forEach(el => {

            el.querySelectorAll('.accordion__toggle').forEach(trigger => {
                trigger.addEventListener('click', e => {
                    el.classList.toggle('open');
                    if(trigger.classList.contains('scroll-into-view')) {
                        const y = el.getBoundingClientRect().top + window.pageYOffset - 110;
                        window.scrollTo({top: y, behavior: trigger.classList.contains('smooth') ? 'smooth' : 'auto'});
                    }
                });
            })

        });
    }

});
